'use client';

import React, { type CSSProperties, type ReactNode } from 'react';

/**
 * Metric — tabular monospaced number.
 *
 * For any figure the user reads as data: kcal, macros, weights, timers.
 * `tabular-nums` keeps digits column-aligned so lists/counters don't jitter.
 * Falls back to a system mono until a brand mono (e.g. JetBrains Mono) is
 * bundled and prepended to the stack.
 */
const MONO =
  "'JetBrains Mono', ui-monospace, SFMono-Regular, 'SF Mono', Menlo, monospace";

export interface MetricProps {
  children: ReactNode;
  /** Font size in px. Default 15. */
  size?: number;
  /** Font weight. Default 700. */
  weight?: number;
  /** Text color. Default: inherit from parent. */
  color?: string;
  style?: CSSProperties;
}

export function Metric({ children, size = 15, weight = 700, color, style }: MetricProps) {
  return (
    <span
      style={{
        fontFamily: MONO,
        fontSize: size,
        fontWeight: weight,
        fontVariantNumeric: 'tabular-nums',
        letterSpacing: '-0.02em',
        color,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
